import Vue from 'vue';

export class Alerts {

    /**
     *
     * @return {Promise}
     */
    static grid() {
        return new Promise((ok, fail) => {
            Vue.http.get('grid/alertas')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static byPK(idAlertas) {
        return new Promise((ok, fail) => {
            Vue.http.get('alerta/' + idAlertas)
            //Vue.http.get('alertas/by-pk/' + idAlertas)
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static details(idAlertas) {
        return new Promise((ok, fail) => {
            Vue.http.get('alertas/' + idAlertas + '/details')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static count() {
        return new Promise((ok, fail) => {
            Vue.http.get('alertas/count')
                .then((res) => ok(res.data.count))
                .catch((err) => fail(err));
        });
    }

    static lasts() {
        return new Promise((ok, fail) => {
            Vue.http.get('alertas/lasts')
                .then((res) => ok(res.data))
                .catch((err) => fail(err));
        });
    }

    static finalizar(json) {
        return Vue.http.post('alerta/finalizar', json);
    }

    static finalizarTodos() {
        return Vue.http.post('alerta/finalizar/todos', {});
    }

}
